module.exports = __webpack_public_path__ + "img/Group 2022.ab0e92b3.png";